export const onlineLocationList = [
  'SOBES.RU',
  'Skype',
  'Zoom',
  'Whatsapp',
  'Telegram',
  'Яндекс Телемост'
];